export const colors = {
  bg: "#1a1a1a",
  surface: "#222",
  surfaceElevated: "#2a2a2a",
  text: "#fff",
  textMuted: "#999",
  textDim: "#666",
  accent: "#ff6b35",
  accentHover: "#ff8559",
  success: "#4ade80",
  danger: "#ef4444",
  warning: "#facc15",
  border: "#333",
} as const;

export const spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
} as const;

export const radius = {
  sm: 4,
  md: 8,
  lg: 12,
  pill: 999,
} as const;

export const fontSize = {
  xs: 11,
  sm: 13,
  md: 15,
  lg: 18,
  xl: 24,
  xxl: 32,
} as const;

export const trainerColors = {
  primary: "#1a1a2e",
  primaryHover: "#2d2d4a",
  white: "#fff",
  gray50: "#f9fafb",
  gray100: "#f3f4f6",
  gray200: "#e5e7eb",
  gray300: "#d1d5db",
  gray400: "#ccc",
  gray500: "#999",
  gray600: "#666",
  gray700: "#555",
  gray800: "#374151",
  gray900: "#111",
  lightBg: "#f5f5f5",
  lightBg2: "#f8f9fa",
  lightBorder: "#e0e0e8",
  lightBorderDark: "#e8e8ef",
  blue: "#3b82f6",
  blueLight: "#f0f7ff",
  red: "#ef4444",
  redLight: "#fef2f2",
  redBorder: "#fecaca",
  redDark: "#991b1b",
  green: "#10b981",
  greenLight: "#f0fdf4",
  greenBorder: "#bbf7d0",
  greenDark: "#166534",
  greenBg: "#dcfce7",
  greenCheck: "#22c55e",
  amber: "#f59e0b",
  amberLight: "#fef3c7",
  purple: "#8b5cf6",
  purpleLight: "#e0e7ff",
  cyan: "#06b6d4",
  indigo: "#4f46e5",
  indigoHover: "#4338ca",
} as const;
